/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The way tax should be handled for a certain price.
 */
export const TaxBehavior = /* #__PURE__ */ parsers.exactly('inclusive', 'exclusive', 'disabled');
